import _ from 'lodash';
import React from 'react';
import MultiSelect from '../MultiSelect';
import opportunityStageCategories from '~/lookups/opportunity-stage-categories';

const defaultOptions = _.values(opportunityStageCategories);

export default function OpportunityStageCategoryFilter({
  placeholder = 'Opportunity Stage Category',
  name,
  value,
  onChange,
  options = defaultOptions,
}) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
